export const NEWSLETTER_CARD_ID = 'newsletter-card'
export const NEWSLETTER_TITLE_ID = 'newsletter-title'
